import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/ArrowDropDown';

class ArrowDropDownIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default ArrowDropDownIcon;
